/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatInferencerPolymorphic } from './SingleTurnChatInferencerPolymorphic';
import {
  SingleTurnChatInferencerPolymorphicFromJSON,
  SingleTurnChatInferencerPolymorphicFromJSONTyped,
  SingleTurnChatInferencerPolymorphicToJSON,
} from './SingleTurnChatInferencerPolymorphic';

/**
 *
 * @export
 * @interface PaginatedSingleTurnChatInferencerPolymorphicList
 */
export interface PaginatedSingleTurnChatInferencerPolymorphicList {
  /**
   *
   * @type {number}
   * @memberof PaginatedSingleTurnChatInferencerPolymorphicList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedSingleTurnChatInferencerPolymorphicList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedSingleTurnChatInferencerPolymorphicList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<SingleTurnChatInferencerPolymorphic>}
   * @memberof PaginatedSingleTurnChatInferencerPolymorphicList
   */
  results: Array<SingleTurnChatInferencerPolymorphic>;
}

/**
 * Check if a given object implements the PaginatedSingleTurnChatInferencerPolymorphicList interface.
 */
export function instanceOfPaginatedSingleTurnChatInferencerPolymorphicList(
  value: object,
): value is PaginatedSingleTurnChatInferencerPolymorphicList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedSingleTurnChatInferencerPolymorphicListFromJSON(
  json: any,
): PaginatedSingleTurnChatInferencerPolymorphicList {
  return PaginatedSingleTurnChatInferencerPolymorphicListFromJSONTyped(json, false);
}

export function PaginatedSingleTurnChatInferencerPolymorphicListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedSingleTurnChatInferencerPolymorphicList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(SingleTurnChatInferencerPolymorphicFromJSON),
  };
}

export function PaginatedSingleTurnChatInferencerPolymorphicListToJSON(
  value?: PaginatedSingleTurnChatInferencerPolymorphicList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(SingleTurnChatInferencerPolymorphicToJSON),
  };
}
